import {MarkerClusterer} from "@react-google-maps/api";
import propTypes from "prop-types";

import s from "./TFCluster.module.css";
import {useFindOrganizationsMapStore, useMapStore} from "../store.jsx";
import TFMarker from "./TFMarker.jsx";
import Each from "../../utils/Each.tsx";
import debounce from "../../utils/debounce";
import {useEffect} from "react";

export default function TFCluster({
    onClusteringEnd,
    handleOrganizationIcons,
}) {
    const { organizations, groupedOrganizations, findOrganizationGroup } =
        useFindOrganizationsMapStore();
    
    const map = useMapStore((state) => state.map);
    const setClusterer = useMapStore((state) => state.setClusterer);
    const clusterer = useMapStore((state) => state.clusterer);

    useEffect(() => {
        if(!clusterer) return;
        clusterer.getClusters().forEach((cluster) => {
            cluster.clearMarkers()
        })
    }, [organizations]);

    function shouldHideMarker(item, map, clusterer) {
        if (!map) return false;

        const bounds = map.getBounds();
        if (!bounds) return false;
        
        const slightlyBiggerBounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(
                bounds.getSouthWest().lat() - 0.5,
                bounds.getSouthWest().lng() - 0.5,
            ),
            new window.google.maps.LatLng(
                bounds.getNorthEast().lat() + 0.5,
                bounds.getNorthEast().lng() + 0.5,
            ));

        const latLng = new window.google.maps.LatLng(
            item.geoLocation.latitude,
            item.geoLocation.longitude,
        );
        
        const isGroupItem = findOrganizationGroup(
            item,
            groupedOrganizations,
        ).indexOf(item) > 0;
        
        let isClustered = false; 
        for(let i = 0; i < clusterer.getClusters().length; i++) {
            const cluster = clusterer.getClusters()[i];
            if(cluster.getBounds().contains(latLng)) {
                isClustered = true;
                break;
            }
        }
        
        return !slightlyBiggerBounds.contains(latLng) || isGroupItem;
    }
        

    return (
        organizations?.result?.length > 0 && (
            <MarkerClusterer
                onClusteringEnd={onClusteringEnd}
                clusterClass={s.root}
                options={{
                    imagePath:
                        "/icons/burgundy-orange/markers/clustermarker",
                    imageExtension: "svg",
                    imageSizes: [44, 54, 64],
                    gridSize: 100,
                    minimumClusterSize: 2,
                    zoomOnClick: true,
                    averageXenter: true,
                    maxZoom: 15,
                    zoomOnClickOptions: { maxZoom: 10 },
                }}
                onLoad={(clusterer) => {
                    setClusterer(clusterer);
                }}
                onUnmount={(clusterer) => {
                    setClusterer(null);
                }}
            >
                {(clusterer) => (
                    <Each
                        of={organizations.result}
                        render={(item, index) =>
                            !!item?.geoLocation?.latitude &&
                            !!item?.geoLocation?.longitude && (
                                <TFMarker
                                    key={`marker-${item.name}+${index}`}
                                    item={item}
                                    cluster={clusterer}
                                    handleOrganizationIcons={
                                        handleOrganizationIcons
                                    }
                                    index={index}
                                    group={findOrganizationGroup(
                                        item,
                                        groupedOrganizations,
                                    )}
                                    hide={shouldHideMarker(item, map, clusterer)}
                                />
                            )
                        }
                    />
                )}
            </MarkerClusterer>
        )
    );
}

TFCluster.propTypes = {
    onClusteringEnd: propTypes.func,
    mapRef: propTypes.object,
    handleOrganizationIcons: propTypes.func,
};
